import { Card } from 'azure-devops-ui/Card';
import { Header, TitleSize } from 'azure-devops-ui/Header';
import { Page } from 'azure-devops-ui/Page';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Personas from '../../common/components/projectSettings/persona/Personas';
import { useProjectContextProviderContext } from '../../common/hooks/useProjectContextProviderContext';
import { ProjectContext } from '../../common/clients/ogg';
import Loading from '../../common/components/Loading';
import DefinitionOfReady from '../../common/components/projectSettings/dor/DefinitionOfReady';
import { syncProjectContext } from '../components/examples';

export default function ProjectSettingsView() {
  const navigate = useNavigate();
  const projectContextProvider = useProjectContextProviderContext();
  const [context, setContext] = useState(null as ProjectContext);
  const { sampleId } = useParams();

  useEffect(() => {
    getContext();
  }, [projectContextProvider]);

  async function getContext() {
    let c = await projectContextProvider.getProjectContext();

    // Try populating the project context from the current sample, unless already populated
    if (!c) {
      syncProjectContext(sampleId, projectContextProvider);
      c = await projectContextProvider.getProjectContext();
    }

    setContext(c ?? ({} as ProjectContext));
  }

  console.log('loading project settings', context, sampleId);

  return (
    <div className='flex-row justify-center full-width'>
      <Page className='project-settings'>
        <Header
          title={'Project Settings'}
          titleSize={TitleSize.Medium}
          backButtonProps={{ onClick: () => navigate(`/${sampleId ?? ''}`) }}
          titleAriaLevel={3}
        />

        <div className='page-content page-content-top'>
          {context == null ? (
            <Loading title='Loading project settings' subtitle='Gathering the data, just a sec' />
          ) : (
            <div className='flex-column rhythm-vertical-16'>
              <Card>
                <Personas personas={context.eligiblePersonas} projectContext={context} />
              </Card>
              <Card>
                <DefinitionOfReady dor={context.definitionOfReady} projectContext={context} />
              </Card>
            </div>
          )}
        </div>
      </Page>
    </div>
  );
}
